import { api } from "../../http";

async function GetDataAllMateria() {
  try {
    
    const data = await api.get(`/materias`);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetDataAllMateria };
